/*
 *
 * Estos componentes estan presentes solo en el website
 *
 */

const page="./page/";
// Bootstrap-Vue eliminado - no se estaba usando, solo Bootstrap CSS

function plugin (Vue) {
	Vue.component('my-header', require(page+'shared/header.vue').default);
	Vue.component('my-footer', require(page+'shared/footer.vue').default);
	Vue.component('product-card', require(page+'shared/product-card.vue').default);
}

// Install by default if using the script tag
if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(plugin)
}

export default plugin
